import React, { useState, useEffect, useCallback } from 'react';
import { Mail, Loader2, Eye, X, Send, AlertTriangle, TrendingDown, PackageCheck, FlaskConical, AlertCircle, CheckCircle, ClipboardList, BellRing, ShoppingBag, Truck, Wallet, MessageSquare, Star, KeyRound, LineChart, CalendarDays, Wrench, Languages, UserPlus } from 'lucide-react';
import { Button } from './ui/button';
import { api, adminAPI } from '../services/api';
import AdminEmailTemplatesModal from './AdminEmailTemplatesModal';
import EmailDeliverabilityCard from './EmailDeliverabilityCard';

const KIND = {
  weekly_digest: { label: 'Résumé hebdomadaire', icon: CalendarDays, cls: 'bg-indigo-50 text-indigo-700' },
  competitor_alert: { label: 'Alerte prix concurrent', icon: LineChart, cls: 'bg-red-50 text-red-700' },
  price_drop: { label: 'Baisse de prix', icon: TrendingDown, cls: 'bg-red-50 text-red-700' },
  back_in_stock: { label: 'Retour en stock', icon: PackageCheck, cls: 'bg-green-50 text-green-700' },
  back_in_stock_followup: { label: 'Relance retour en stock', icon: PackageCheck, cls: 'bg-amber-50 text-amber-700' },
  test: { label: 'Test', icon: FlaskConical, cls: 'bg-gray-100 text-gray-600' },
  template_test: { label: 'Test de modèle', icon: Languages, cls: 'bg-gray-100 text-gray-600' },
  purchase_order: { label: 'Bon de commande', icon: ClipboardList, cls: 'bg-blue-50 text-blue-700' },
  purchase_order_reminder: { label: 'Relance fournisseur', icon: BellRing, cls: 'bg-red-50 text-red-700' },
  order_confirmation: { label: 'Confirmation de commande', icon: ShoppingBag, cls: 'bg-orange-50 text-orange-700' },
  order_shipped: { label: 'Expédition', icon: Truck, cls: 'bg-green-50 text-green-700' },
  wallet_credit: { label: 'Avoir crédité', icon: Wallet, cls: 'bg-emerald-50 text-emerald-700' },
  order_refund: { label: 'Remboursement carte (SumUp)', icon: Wallet, cls: 'bg-emerald-50 text-emerald-700' },
  contact_received: { label: 'Contact reçu', icon: MessageSquare, cls: 'bg-purple-50 text-purple-700' },
  contact_ack: { label: 'Accusé de réception', icon: MessageSquare, cls: 'bg-gray-100 text-gray-600' },
  contact_reply: { label: 'Réponse client', icon: MessageSquare, cls: 'bg-blue-50 text-blue-700' },
  review_reply: { label: 'Réponse à un avis', icon: MessageSquare, cls: 'bg-yellow-50 text-yellow-800' },
  review_reminder: { label: "Rappel d'avis", icon: Star, cls: 'bg-yellow-50 text-yellow-800' },
  cart_reminder: { label: 'Relance panier abandonné', icon: ShoppingBag, cls: 'bg-orange-50 text-orange-700' },
  tyre_season: { label: 'Relance pneus saison', icon: ShoppingBag, cls: 'bg-sky-50 text-sky-700' },
  cart_reminder_tyres: { label: 'Relance panier pneus', icon: ShoppingBag, cls: 'bg-orange-50 text-orange-700' },
  welcome: { label: 'Bienvenue', icon: UserPlus, cls: 'bg-emerald-50 text-emerald-700' },
  admin_new_user: { label: 'Copie admin — inscription', icon: UserPlus, cls: 'bg-gray-100 text-gray-700' },
  notif_digest: { label: 'Résumé hebdo notifications', icon: BellRing, cls: 'bg-emerald-50 text-emerald-700' },
  cron_failure: { label: 'Tâche planifiée en échec', icon: AlertTriangle, cls: 'bg-red-50 text-red-700' },
  payment_reminder: { label: 'Rappel de paiement (lien SumUp)', icon: AlertTriangle, cls: 'bg-orange-50 text-orange-700' },
  order_unpaid_cancelled: { label: 'Commande impayée annulée (24 h)', icon: AlertTriangle, cls: 'bg-amber-50 text-amber-700' },
  cron_health: { label: 'Santé hebdo des tâches', icon: CheckCircle, cls: 'bg-sky-50 text-sky-700' },
  admin_daily: { label: 'Résumé quotidien admin', icon: CalendarDays, cls: 'bg-indigo-50 text-indigo-700' },
  password_reset: { label: 'Réinitialisation mot de passe', icon: KeyRound, cls: 'bg-slate-100 text-slate-700' },
  question_answered: { label: 'Réponse à une question', icon: MessageSquare, cls: 'bg-orange-50 text-orange-700' },
  fitting_centre: { label: 'Montage → centre', icon: Wrench, cls: 'bg-orange-50 text-orange-700' },
  fitting_appointment: { label: 'RDV montage confirmé', icon: Wrench, cls: 'bg-green-50 text-green-700' },
  fitting_reminder: { label: 'Rappel montage J-1', icon: BellRing, cls: 'bg-sky-50 text-sky-700' },
  fitting_review_request: { label: 'Avis centre de montage', icon: Star, cls: 'bg-amber-50 text-amber-800' },
  fitting_review_reply: { label: 'Réponse du centre', icon: MessageSquare, cls: 'bg-amber-50 text-amber-800' },
  fitting_change: { label: 'Créneau déplacé / annulé', icon: Wrench, cls: 'bg-red-50 text-red-700' },
  fitting_unconfirmed: { label: 'Alerte centre sans réponse', icon: AlertCircle, cls: 'bg-red-50 text-red-700' },
  fitting_reassigned: { label: 'Montage réaffecté', icon: Wrench, cls: 'bg-purple-50 text-purple-700' },
  fitting_auto_reassigned: { label: 'Récap réaffectation auto', icon: Wrench, cls: 'bg-purple-50 text-purple-700' },
  fitting_hidden: { label: 'Centre masqué (fiabilité)', icon: AlertCircle, cls: 'bg-red-50 text-red-700' },
  fitting_visible_again: { label: 'Centre réaffiché', icon: Wrench, cls: 'bg-green-50 text-green-700' },
  fitting_schedule_link: { label: 'Lien horaires centre', icon: CalendarDays, cls: 'bg-indigo-50 text-indigo-700' },
};
const STATUS = { simulated: 'bg-amber-50 text-amber-700', sent: 'bg-green-50 text-green-700', failed: 'bg-red-50 text-red-700', pending: 'bg-gray-100 text-gray-600' };

const AdminEmailsPanel = () => {
  const [data, setData] = useState(null);
  const [filter, setFilter] = useState('');
  const [preview, setPreview] = useState(null);
  const [sending, setSending] = useState(false);
  const [resending, setResending] = useState(null);
  const resend = async (id) => {
    setResending(id); setMessage(null);
    try {
      const r = await adminAPI.resendEmail(id);
      await load();
      setMessage(r.status === 'sent' ? { type: 'success', text: `E-mail renvoyé à ${r.to}` } : { type: 'error', text: `Renvoi en échec : ${r.error || 'erreur inconnue'}` });
    } catch (e) { setMessage({ type: 'error', text: e.response?.data?.detail || 'Renvoi impossible' }); } finally { setResending(null); }
  };
  const [message, setMessage] = useState(null);
  const [digest, setDigest] = useState(null);
  const [sendingDigest, setSendingDigest] = useState(false);
  const [sendingNotifDigest, setSendingNotifDigest] = useState(false);
  const [showTemplates, setShowTemplates] = useState(false);

  const loadDigest = () => api.get('/admin/digest/status').then(r => setDigest(r.data)).catch(() => {});
  useEffect(() => { loadDigest(); }, []);

  const sendDigest = async () => {
    setSendingDigest(true);
    setMessage(null);
    try {
      const r = await api.post('/admin/digest/send');
      await Promise.all([load(), loadDigest()]);
      setMessage({ type: 'success', text: `Résumé hebdo ${r.data.status === 'simulated' ? 'enregistré dans le journal (mode simulation)' : 'envoyé'} à ${r.data.to} : « ${r.data.subject} »` });
    } catch (e) {
      setMessage({ type: 'error', text: e.response?.data?.detail || "Échec de l'envoi du résumé" });
    } finally {
      setSendingDigest(false);
    }
  };

  const load = useCallback(async () => {
    const r = await api.get('/admin/emails', { params: filter ? { kind: filter } : {} });
    setData(r.data);
  }, [filter]);

  useEffect(() => { load().catch(() => setData({ emails: [], stats: {}, provider: '?', from: '' })); }, [load]);

  const open = async (id) => {
    const r = await api.get(`/admin/emails/${id}`);
    setPreview(r.data);
  };

  const sendTest = async () => {
    setSending(true);
    setMessage(null);
    try {
      const r = await api.post('/admin/emails/test');
      await load();
      setMessage({ type: 'success', text: `E-mail de test ${r.data.status === 'simulated' ? 'enregistré dans le journal (mode simulation)' : 'envoyé'} à ${r.data.to}` });
    } catch (e) {
      setMessage({ type: 'error', text: e.response?.data?.detail || "Échec de l'envoi" });
    } finally {
      setSending(false);
    }
  };

  const total = data ? Object.values(data.stats).reduce((a, b) => a + b, 0) : 0;

  return (
    <>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">E-mails ({total})</h1>
          <p className="text-sm text-gray-500" data-testid="emails-provider">
            Fournisseur : <span className="font-medium">{data?.provider === 'simulation' ? 'aucun — mode simulation (journal uniquement)' : data?.provider === 'smtp' ? 'SMTP Hostinger — envoi réel' : data?.provider}</span> · Expéditeur : <span className="font-mono">{data?.from || '—'}</span>
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Button data-testid="emails-open-templates" onClick={() => setShowTemplates(true)} variant="outline" className="border-slate-300 text-slate-700 hover:bg-slate-50">
            <Languages size={16} className="mr-1" /> Aperçu des modèles (5 langues)
          </Button>
          <Button data-testid="emails-send-digest" onClick={sendDigest} disabled={sendingDigest} className="bg-[#1e3a5f] hover:bg-[#2d4a6f]" title={digest?.schedule ? `${digest.schedule} · prochain envoi ${new Date(digest.next_auto).toLocaleString('fr-FR')}` : ''}>
            {sendingDigest ? <Loader2 size={16} className="mr-1 animate-spin" /> : <CalendarDays size={16} className="mr-1" />} Envoyer le résumé hebdo maintenant
          </Button>
          <Button data-testid="emails-send-notif-digest" onClick={async () => { setSendingNotifDigest(true); try { const r = await api.post('/admin/notifications/digest/run?force=true'); alert(`Résumé notifications clients : ${r.data.sent} envoyé(s), ${r.data.skipped} ignoré(s) (sans notification non lue ou canal désactivé).`); load(); } catch { alert('Envoi impossible'); } finally { setSendingNotifDigest(false); } }} disabled={sendingNotifDigest} variant="outline" className="border-emerald-400 text-emerald-700 hover:bg-emerald-50" title="Cron : chaque lundi 8h (Paris) — clients ayant activé « Résumé hebdomadaire »">
            {sendingNotifDigest ? <Loader2 size={16} className="mr-1 animate-spin" /> : <BellRing size={16} className="mr-1" />} Résumé notifications clients
          </Button>
          <Button data-testid="emails-send-test" onClick={sendTest} disabled={sending} variant="outline" className="border-orange-400 text-orange-700 hover:bg-orange-50">
            {sending ? <Loader2 size={16} className="mr-1 animate-spin" /> : <Send size={16} className="mr-1" />} Envoyer un e-mail de test
          </Button>
        </div>
      </div>
      <EmailDeliverabilityCard />
      {digest && (
        <p className="text-xs text-gray-500 -mt-3 mb-4 flex items-center gap-1.5" data-testid="emails-digest-status">
          <CalendarDays size={12} /> Résumé hebdomadaire admin : {digest.schedule.toLowerCase()} · prochain envoi automatique le {new Date(digest.next_auto).toLocaleString('fr-FR', { weekday: 'long', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Paris' })}
          {digest.last && <> · dernier envoi {new Date(digest.last.sent_at).toLocaleString('fr-FR')} ({digest.last.trigger === 'auto' ? 'automatique' : 'manuel'})</>}
        </p>
      )}

      {data?.provider === 'simulation' && (
        <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800" data-testid="emails-simulation-banner">
          <strong>Mode simulation :</strong> les alertes (baisse de prix, retour en stock) sont générées et archivées ici mais ne sont pas réellement envoyées. Fournissez une clé Resend / SendGrid ou des identifiants SMTP pour activer l'envoi réel.
        </div>
      )}

      {message && (
        <p data-testid="emails-message" className={`mb-4 text-sm flex items-center gap-2 ${message.type === 'error' ? 'text-red-600' : 'text-green-700'}`}>
          {message.type === 'error' ? <AlertCircle size={16} /> : <CheckCircle size={16} />} {message.text}
        </p>
      )}

      <div className="flex flex-wrap gap-2 mb-4">
        {[['', 'Tous'], ['weekly_digest', 'Résumés hebdo'], ['competitor_alert', 'Alertes concurrents'], ['price_drop', 'Baisses de prix'], ['back_in_stock', 'Retours en stock'], ['test', 'Tests']].map(([k, l]) => (
          <button key={k} type="button" data-testid={`emails-filter-${k || 'all'}`} onClick={() => setFilter(k)} className={`text-sm px-3 py-1.5 rounded-full border transition-colors ${filter === k ? 'bg-orange-500 text-white border-orange-500' : 'bg-white text-gray-700 border-gray-300 hover:border-orange-400'}`}>{l}</button>
        ))}
      </div>

      {!data ? (
        <div className="flex justify-center py-12"><Loader2 className="animate-spin text-orange-500" /></div>
      ) : data.emails.length === 0 ? (
        <div className="bg-white rounded-lg shadow-sm p-12 text-center text-gray-500" data-testid="emails-empty">
          <Mail size={32} className="mx-auto mb-3 text-gray-300" /> Aucun e-mail dans le journal. Les alertes se déclenchent lorsque vous baissez le prix ou remettez en stock une pièce présente dans des listes de souhaits.
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow-sm overflow-x-auto">
          <table className="rt-cards w-full text-sm">
            <thead className="bg-gray-50 text-left text-xs uppercase text-gray-500">
              <tr><th className="px-4 py-3">Date</th><th className="px-4 py-3">Type</th><th className="px-4 py-3">Destinataire</th><th className="px-4 py-3">Objet</th><th className="px-4 py-3">Statut</th><th className="px-4 py-3"></th></tr>
            </thead>
            <tbody className="divide-y" data-testid="emails-table">
              {data.emails.map(e => {
                const k = KIND[e.kind] || { label: e.kind, icon: Mail, cls: 'bg-gray-100 text-gray-600' };
                const Icon = k.icon;
                return (
                  <tr key={e.id} data-testid={`email-row-${e.id}`} className="hover:bg-gray-50">
                    <td data-label="Date" className="px-4 py-3 whitespace-nowrap text-gray-500">{new Date(e.created_at).toLocaleString('fr-FR')}</td>
                    <td data-label="Type" className="px-4 py-3"><span className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full ${k.cls}`}><Icon size={12} /> {k.label}</span></td>
                    <td data-label="Destinataire" className="px-4 py-3 font-mono text-xs">{e.to}</td>
                    <td data-label="Objet" className="px-4 py-3 max-w-md truncate">{e.subject}</td>
                    <td data-label="Statut" className="px-4 py-3"><span className={`text-xs px-2 py-0.5 rounded-full ${STATUS[e.status] || STATUS.pending}`} data-testid={`email-status-${e.id}`}>{e.status === 'simulated' ? 'Simulé' : e.status === 'sent' ? 'Envoyé' : e.status === 'failed' ? 'Échec' : e.status}</span></td>
                    <td className="px-4 py-3 text-right whitespace-nowrap">
                      {e.status === 'failed' && <button data-testid={`email-resend-${e.id}`} onClick={() => resend(e.id)} disabled={resending === e.id} className="p-1.5 text-orange-600 hover:bg-orange-50 rounded disabled:opacity-50" title={`Renvoyer${e.error ? ` — ${e.error}` : ''}`}>{resending === e.id ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />}</button>}
                      <button data-testid={`email-preview-${e.id}`} onClick={() => open(e.id)} className="p-1.5 text-blue-600 hover:bg-blue-50 rounded" title="Aperçu"><Eye size={15} /></button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {showTemplates && <AdminEmailTemplatesModal onClose={() => setShowTemplates(false)} onSent={() => load().catch(() => {})} />}

      {preview && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[92vh] flex flex-col overflow-hidden" data-testid="email-preview">
            <div className="p-4 border-b flex items-start justify-between gap-4">
              <div className="min-w-0">
                <p className="font-semibold text-gray-900 truncate" data-testid="email-preview-subject">{preview.subject}</p>
                <p className="text-xs text-gray-500 font-mono">De : {preview.from || '—'} · À : {preview.to} · {new Date(preview.created_at).toLocaleString('fr-FR')}</p>
                {preview.error && <p className="text-xs text-red-600 mt-1">{preview.error}</p>}
              </div>
              <button onClick={() => setPreview(null)} className="text-gray-400 hover:text-gray-700"><X size={22} /></button>
            </div>
            <iframe title="Aperçu e-mail" srcDoc={preview.html} className="flex-1 min-h-[520px] w-full bg-gray-100" sandbox="" />
          </div>
        </div>
      )}
    </>
  );
};

export default AdminEmailsPanel;
